import React from "react"
import "./Layout.scss"
import Header from "@components/Header/Header"
// import Footer from "@components/Footer/Footer"
import clsx from "clsx"
import loadable from "@loadable/component"
import { useLocation } from "@reach/router"

const Footer = loadable(() => import("@components/Footer/Footer"))

const Layout = ({ children, pageData, removeFixedHeader, popularSearch, popularSearchObject, popularSearchDetailsObject }) => {
  const { custom_css_classname, layout, menu, page_name, select_popular_search } = pageData || {}
  const { pathname } = useLocation()
  let popularSearchName = select_popular_search?.title;
  if (popularSearch) {
    popularSearchName = popularSearch;
  }
  //console.log("pathname", pathname)

  return (
    <section
      className={clsx(
        custom_css_classname,
        "page-layout-wrap",
        !!layout && `${layout}-layout`,
      )}
    >
      <Header menu_slug={menu?.slug} removeFixedHeader={removeFixedHeader} />
      <main className="page-layout-section">{children}</main>
      {pathname === "/online-auctions/" && <script src="https://webbers.bambooauctions.com/js/bamboo-wl.js"></script>}

      <Footer
        popularSearch={popularSearchName}
        page={page_name} 
        popularSearchObject={popularSearchObject}
        popularSearchDetailsObject={popularSearchDetailsObject} 
        />
    </section>
  )
}

export default Layout